// extracted by mini-css-extract-plugin
module.exports =  {"preloader":"_2787e5dfdf--preloader--futYv","spin":"_2787e5dfdf--spin--boFQ3"};